import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field', 'phoneField', 'localField']

  connect() {
    this.localFieldTargets.forEach(input => {
      if (input.type !== 'checkbox') return
      const key = input.dataset.localPref
      if (!key) return
      const fallback = input.dataset.localPrefDefault !== 'false'
      const stored = localStorage.getItem(key)
      input.checked = stored === null ? fallback : stored !== 'false'
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  async save() {
    this.persistLocalPreferences()

    const data = {}
    this.fieldTargets.forEach(input => {
      if (input.type === 'checkbox') {
        data[input.name] = input.checked
      } else if (input.name === 'phone') {
        data[input.name] = input.value.replace(/\D/g, '')
      } else {
        data[input.name] = input.value
      }
    })

    if (data.phone && !this.validatePhone(data.phone)) return

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      const response = await fetch('/api/v1/profile', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({ profile: data })
      })

      const result = await response.json()

      if (response.ok) {
        this.element.close()
        this.updateSidebarName(result.real_name)
        this.syncNotificationGlobals(result)
        window.showSuccessNotification('Perfil atualizado com sucesso')
      } else {
        const message = result.errors?.join(', ') || 'Erro ao atualizar perfil'
        window.showErrorNotification(message)
      }
    } catch {
      window.showErrorNotification('Erro de conexão')
    }
  }

  syncNotificationGlobals(result) {
    const flags = [
      'message_sound_enabled',
      'message_toast_enabled',
      'new_conversation_sound_enabled',
      'new_conversation_toast_enabled',
      'assignment_sound_enabled',
      'assignment_toast_enabled'
    ]
    flags.forEach(flag => {
      if (typeof result[flag] === 'boolean') window[flag] = result[flag]
    })
  }

  persistLocalPreferences() {
    this.localFieldTargets.forEach(input => {
      if (input.type !== 'checkbox') return
      const key = input.dataset.localPref
      if (!key) return
      const value = String(input.checked)
      localStorage.setItem(key, value)
      window.dispatchEvent(
        new CustomEvent('local-preference-changed', { detail: { key, value: input.checked } })
      )
    })
  }

  formatPhone() {
    if (!this.hasPhoneFieldTarget) return

    let value = this.phoneFieldTarget.value.replace(/\D/g, '')
    let formatted = ''

    if (value.length > 0) {
      if (value.startsWith('55')) {
        if (value.length <= 2) {
          formatted = `+${value}`
        } else if (value.length <= 4) {
          formatted = `+${value.slice(0, 2)} (${value.slice(2)}`
        } else if (value.length <= 9) {
          formatted = `+${value.slice(0, 2)} (${value.slice(2, 4)}) ${value.slice(4)}`
        } else {
          formatted = `+${value.slice(0, 2)} (${value.slice(2, 4)}) ${value.slice(4, 9)}-${value.slice(9, 13)}`
        }
      } else if (value.startsWith('1')) {
        if (value.length <= 1) {
          formatted = `+${value}`
        } else if (value.length <= 4) {
          formatted = `+${value.slice(0, 1)} (${value.slice(1)}`
        } else if (value.length <= 7) {
          formatted = `+${value.slice(0, 1)} (${value.slice(1, 4)}) ${value.slice(4)}`
        } else {
          formatted = `+${value.slice(0, 1)} (${value.slice(1, 4)}) ${value.slice(4, 7)}-${value.slice(7, 11)}`
        }
      } else {
        if (value.length <= 2) {
          formatted = `+${value}`
        } else if (value.length <= 6) {
          formatted = `+${value.slice(0, 2)} ${value.slice(2)}`
        } else if (value.length <= 10) {
          formatted = `+${value.slice(0, 2)} ${value.slice(2, 6)} ${value.slice(6)}`
        } else {
          formatted = `+${value.slice(0, 2)} ${value.slice(2, 6)} ${value.slice(6, 10)} ${value.slice(10, 14)}`
        }
      }
    }

    this.phoneFieldTarget.value = formatted
  }

  validatePhone(digits) {
    if (digits.startsWith('55')) {
      if (digits.length !== 12 && digits.length !== 13) {
        window.showErrorNotification('Número brasileiro inválido. Use: +55 (DD) 99999-9999')
        return false
      }
    } else if (digits.startsWith('1')) {
      if (digits.length !== 11) {
        window.showErrorNotification('Número inválido. Use: +1 (NNN) NNN-NNNN')
        return false
      }
    } else if (digits.length < 7 || digits.length > 15) {
      window.showErrorNotification('Número de telefone inválido. Digite com código do país.')
      return false
    }
    return true
  }

  updateSidebarName(name) {
    if (!name) return
    const nameEl = document.querySelector('.user-status-menu .nav-text .text-sm.font-medium')
    if (nameEl) nameEl.textContent = name
  }
}
